import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {PriceLevelReportSelectionData} from "../../../pricing/price-level/controls/price-level-report-selection-control.component";

export class PriceLevelAuditReportData extends ReportData<PriceLevelAuditReportData> {
    @collection() groupBy: string[] = ["none"];
    @field includeItemsAtStandardPrice: boolean = false;
    @collection(PriceLevelReportSelectionData) priceLevels: PriceLevelReportSelectionData[];
}
